let currentProduct = null;
let selectedColour = null;
let selectedSize = null;

function openQuickCheckoutModal(product) {

  currentProduct = product;

  document.getElementById('quick-product-title').textContent =
    product.title;

  const coloursContainer =
    document.getElementById('quick-colours');

  const sizesContainer =
    document.getElementById('quick-sizes');

  coloursContainer.innerHTML = '';
  sizesContainer.innerHTML = '';

  selectedColour = null;
  selectedSize = null;

  product.options.forEach(option => {

    const optionName = option.name.toLowerCase();

    if (
      optionName.includes('colour') ||
      optionName.includes('color')
    ) {

      option.values.forEach(value => {

        coloursContainer.innerHTML += `
          <button
            type="button"
            class="quick-colour"
            data-value="${value}"
          >
            ${value}
          </button>
        `;

      });

    }

    if (optionName.includes('size')) {

      option.values.forEach(value => {

        sizesContainer.innerHTML += `
          <button
            type="button"
            class="quick-size"
            data-value="${value}"
          >
            ${value}
          </button>
        `;

      });

    }

  });

  document.getElementById(
    'quick-checkout-modal'
  ).style.display = 'block';
}

document.addEventListener(
  'click',
  async function (e) {

    if (e.target.id === 'quick-checkout-close') {

      document.getElementById(
        'quick-checkout-modal'
      ).style.display = 'none';

      return;
    }

    const btn = e.target.closest('.quick-checkout-icon');

    if (!btn) return;

    e.preventDefault();
    e.stopPropagation();
    e.stopImmediatePropagation();

    const handle = btn.dataset.productHandle;

    try {

      const response = await fetch(
        `/products/${handle}.js`
      );

      if (!response.ok) {
        throw new Error('Failed to load product');
      }

      const product = await response.json();

      console.log('Product:', product);

      openQuickCheckoutModal(product);

    } catch (error) {

      console.error(
        'Quick checkout error:',
        error
      );

    }

  },
  true
);

document.addEventListener('click', function (e) {

  const colourBtn = e.target.closest('.quick-colour');

  if (colourBtn) {

    document
      .querySelectorAll('.quick-colour')
      .forEach(btn => btn.classList.remove('active'));

    colourBtn.classList.add('active');

    selectedColour = colourBtn.dataset.value;

    console.log('Colour:', selectedColour);
  }

  const sizeBtn = e.target.closest('.quick-size');

  if (sizeBtn) {

    document
      .querySelectorAll('.quick-size')
      .forEach(btn => btn.classList.remove('active'));

    sizeBtn.classList.add('active');

    selectedSize = sizeBtn.dataset.value;

    console.log('Size:', selectedSize);
  }

});

document.addEventListener('click', function (e) {

  const continueBtn =
    e.target.closest('#quick-checkout-continue');

  if (!continueBtn) return;

  console.log('CONTINUE CLICKED');

  if (!selectedColour || !selectedSize) {
    alert('Please select colour and size');
    return;
  }

  const variant = currentProduct.variants.find(v =>
    v.option1 === selectedColour &&
    v.option2 === selectedSize
  );
document.getElementById(
  'quick-checkout-variant-id'
).value = variant.id;
const isPreorder =
  variant.barcode === 'PRE-ORDER';

if (isPreorder) {

  document.getElementById(
    'quick-checkout-modal'
  ).style.display = 'none';

  document.getElementById(
    'preorder-terms-popup'
  ).classList.add('active');

} else {

  fetch('/cart/add.js', {
  method: 'POST',
  headers: {
    'Content-Type': 'application/json'
  },
  body: JSON.stringify({
    id: variant.id,
    quantity: 1
  })
})
.then(() => {
  window.location.href = '/cart';
});

}
console.log(
  'Saved Variant ID:',
  variant.id
);
  console.log('Selected Variant:', variant);

  if (!variant) {
    alert('Variant not found');
    return;
  }

});